<template>
    <div v-if="allConsents.length" style="height: 100%;" class="login-dialog__content-container justify-space-between">
        <div>
            <div class="login-dialog__content-container--logo">
                <img :src="layout == 'portal' ? 'https://umbraco.fixit.no/media/1348/fixit_logo_lilla.png' : $store.getters['cmsConfigHomepage/getLogoLarge'] ? $store.getters['cmsConfigHomepage/getLogoLarge'] : $store.getters['webshop/getChainLogoUrl']" alt="logo" 
                    style="object-fit: contain; margin: auto" :width="$vuetify.breakpoint.smAndDown ? '40%' : '25%'" :class="$vuetify.breakpoint.smAndDown ? 'py-5' : 'py-2'" loading="eager"/>
            </div>
            <div class="d-flex justify-center">
                <p class="profile__container--content__consents--subtitle secondary-font text-center ma-0" :style="layout == 'portal' ? '' : 'color: #222222'">{{layout == 'portal' ? 'Hva trender og når kan jeg gjøre et kupp? Få full oversikt over siste nytt ved å huke av for ønsket informasjon.' : 'Hva trender og når kan jeg gjøre et kupp? Få full oversikt over siste nytt ved å huke av for ønsket informasjon.'}}</p>
            </div>

            <the-consent-toggle 
                class="px-3 my-1 mt-5"
                switchColor="primary" 
                :toggled="{toggleState: isAllToggled(), id: -1, parentDescription: consents[0].description}" 
                @setState="setState" 
                @openDropdown="dropdowns['Informasjon, nyheter og tilbud'] = !dropdowns['Informasjon, nyheter og tilbud']" 
                title="Informasjon, nyheter og tilbud" 
                :icon="dropdowns[consents[0].description] ? 'fxt-chevron-down' : 'fxt-chevron-up'" 
                :indeterminate="indeterminate(consents[0].description)">
            </the-consent-toggle>
            <v-expand-transition>
                <div v-if="dropdowns['Informasjon, nyheter og tilbud']">
                    <div v-for="subConsent in consents[0].children" :key="subConsent.consentTypeId">
                        <the-consent-toggle 
                            class="pr-3 pl-12" 
                            iconSize="20px" 
                            switchColor="primary" 
                            :toggled="{toggleState: subConsent.responseValue, id: subConsent.consentTypeId, parentDescription: consents[0].description}" 
                            :disabled="false" 
                            @setState="setState" 
                            :title="subConsent.consentCategory" 
                            :icon="icon(subConsent.consentTypeId)">
                        </the-consent-toggle>
                    </div>
                </div>
            </v-expand-transition>

            <the-consent-toggle
                class="px-3 my-1" 
                switchColor="primary" 
                :toggled="{toggleState: useSameSettingsGlobally, id: -1}" 
                @setState="toggleGlobalSettings" 
                title="Bruk samme valg for alle nye salonger og Fixit" 
                icon="fxt-smile-beam">
            </the-consent-toggle>
        </div>

        <div>
            <div>
                <!-- <the-consent-toggle  class="px-3" switchColor="primary" :toggled="states.ALL" @setState="setState" title="Hold meg oppdatert! Skru på alle." icon="fxt-check"></the-consent-toggle> -->
                <!-- Temporary 'NEXT STEP' button until the consent backend is ready -->
                <div style="width: 358px; margin: 0 auto">
                    <v-btn block height="44px" outlined color="primary" dark rounded class="mt-6 mb-5" @click="$emit('nextStep','welcome-screen')">
                        Hopp over
                    </v-btn>
                    <v-btn block height="44px" color="primary" dark rounded class="mb-3" @click="saveConsents()">
                        Bekreft
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { TheConsentToggle } from "../CommonComponents"
import ProfileSvc from '../../../services/profile-svc';
let profileSvc = null;
export default {
    name: "the-consent-step",
    components: {
        TheConsentToggle
    },
    props: {
        layout: {
            required: false,
            default: 'chain',
            type: String
        }
    },
    data() {
        return {
            consents: [],
            allConsents: [],
            currentChainId: 0,
            useSameSettingsGlobally: false,
            loading: false,
            allToggled: false,
            dropdowns: {
                'Informasjon, nyheter og tilbud': false,
                'Fordelsprogram': false,
                'Timeanbefalinger': false,
                'Informasjon, nyheter og tilbud fra salonger': false,
                'Informasjon, nyheter og tilbud': false
            }
        };
    },
    methods: {
        async saveConsents() {
            if (this.chainId == 0) {
                await profileSvc.UpdateOnlineSluttKundeConsents(this.bookingApi, this.allConsents)
            } else {
                await profileSvc.UpdateCustomerConsents(this.bookingApi, this.allConsents, this.chainId, this.useSameSettingsGlobally)
            }
            this.$emit('nextStep','welcome-screen')
        },
        setState(state) {
            /**
             * id = -1 means the user clicked a parent consent toggle, which will toggle all subconsents.
             */
            if (state.id != -1) {
                this.consents[0].children.find(x => x.consentTypeId == state.id).responseValue = state.toggleState
            } else {
                var toggleValue = !this.isAllToggled()
                for(var c of this.consents.find(x => x.description == state.parentDescription).children) {
                    c.responseValue = toggleValue
                }

            }
            if (this.useSameSettingsGlobally) {
                this.useSameSettings()
            }
        },
        toggleGlobalSettings(state) {
            this.useSameSettingsGlobally = state.toggleState
            this.useSameSettingsGlobally ? this.useSameSettings() : this.revertToDefaultSettings()
        },
        useSameSettings() {
            for(var c of this.allConsents.filter(x => !x.description.includes('fra fixit') && x.description != 'Fordelsprogram')) {
                for (const type of c.children) {
                    if (this.consents[0].children.find(y => y.consentType == type.consentType)) {
                        type.responseValue = this.consents[0].children.find(y => y.consentType == type.consentType).responseValue
                    } else if (type.consentType == 2) { //timeanbefalinger
                        type.responseValue = this.consents[0].children.find(y => y.consentType == 3).responseValue //If SMS is enabled, also enable timeanbefalinger
                    }
                }
            }
        },
        revertToDefaultSettings() {
            for(var c of this.allConsents.filter(x => !x.description.includes('fra fixit') && x.description != 'Fordelsprogram')) {
                for (const type of c.children) {
                    if (this.consents[0].children.find(y => y.consentType == type.consentType)) {
                        type.responseValue = false
                    } else if (type.consentType == 2) { //timeanbefalinger
                        type.responseValue = false
                    }
                }
            }
        },
        indeterminate(parentDescription) {
            var consents = this.consents.find(x => x.description == parentDescription)
            return consents.children.filter(x => x.responseValue == true).length != 0 && consents.children.filter(x => x.responseValue == true).length != consents.children.length
        },
        isAllToggled() {
            return this.consents.find(x => x.description == 'Informasjon, nyheter og tilbud' || 'Informasjon, nyheter og tilbud fra fixit').children.map(x => x.responseValue).every(state => state === true)
        },
        icon(consentTypeId) {
            switch (consentTypeId) {
                case 1:
                case 2:
                case 3:
                    return 'fxt-comment'
                case 4:
                case 5:
                    return 'fxt-mail'
                case 6:
                    return 'fxt-check'
            }
        },
    },
    computed: {
        consentsDescription() {
            return this.chainId == 0 ? 'Hva trender og når kan jeg gjøre et kupp? Få full oversikt over siste nytt ved å huke av for ønsket informasjon fra Fixit!' : 'Hva trender og når kan jeg gjøre et kupp? Få full oversikt over siste nytt ved å huke av for ønsket informasjon fra Salongen.'
        },
        chainId() {
            return this.layout == 'portal' ? this.currentChainId : this.$store.getters["cmsConfigHomepage/getChainId"] ? this.$store.getters["cmsConfigHomepage/getChainId"] : this.$route.params.chainId
        },
        bookingApi() {
            return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL : process.env.VUE_APP_FIXIT_NO_BOOKING_URL
        },

    },
    async created() {
        profileSvc = await ProfileSvc(this.$axios);
        this.loading = true
        this.allConsents = await profileSvc.GetUserConsents(this.bookingApi, this.chainId)
        this.consents = this.allConsents.filter(x => this.layout == 'portal' ? x.description.includes('fra fixit') : x.description.includes('Informasjon, nyheter og tilbud'))
        this.loading = false
	},
    beforeDestroy() {
		profileSvc = null
	}

};
</script>